/* eslint-disable no-eval */
import { firebase } from '@firebase/app'
import '@firebase/firestore'
import { date } from 'quasar'
import infiniteArray from 'infinite-array'

export default {
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [Object, String, Array, Number]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    }
  },
  data () {
    return {
      value: this.config.hasOwnProperty('value') ? this.config.value : this.modelProps,
      formatedString: '',
      color: infiniteArray(['teal', 'orange', 'red', 'deep-orange', 'primary', 'black', 'pink']),
      adapterData: {}
    }
  },
  created () {
    if (this.modelProps instanceof firebase.firestore.Timestamp) {
      this.value = date.formatDate(this.modelProps.toDate(), this.$store.state.config.defaultDateFormat)
    }
    if (typeof this.modelProps === 'number') {
      this.value = Number(this.modelProps).toFixed(2)
    }
    if (this.config.hasOwnProperty('format') && !this.config.chipMode) {
      // eslint-disable-next-line no-eval
      this.formatedString = eval(this.config.format)
    }
    if (this.config.hasOwnProperty('format') && this.config.chipMode && this.config.hasOwnProperty('adapterData')) {
      this.adapterData = []
      for (let key in this.value) {
        this.adapterData.push(this._.cloneDeep(this.value[key]))
      }
    }
  },
  model: {
    prop: 'modelProps',
    event: 'not-mutable'
  },
  methods: {
    formatString (string) {
      return eval(string)
    },
    validate () {}
  },
  watch: {
    modelProps: {
      handler: function (newValue) {
        if (this.config.watch) {
          this.value = this._.cloneDeep(newValue)
          if (this.config.hasOwnProperty('format')) {
            // eslint-disable-next-line no-eval
            this.formatedString = eval(this.config.format)
          }
        }
      },
      deep: true
    }
  }
}
